import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b6db8f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photo-screen" }
const _hoisted_2 = { class: "photo-screen__text" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { for: "fileElem" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "photo-screen__hint" }, " На фото должно быть хорошо видно ваше лицо ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "photo-screen__hint" }, " Принимаются фогографии до 5 mb в формате .jpg или .png ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "photo-screen__hint" }, " Кликните по этому полю или перетащите сюда фотографию ", -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

import SelectScreenTextBg from "@/components/svg/SelectScreenTextBg.vue";
import {
  computed,
  inject,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
} from "vue";
import CircleLoader from "@/components/CircleLoader.vue";
import { getFilmId } from "@/utils/get-film-id";
import EmbededPogressBar from "@/components/EmbededPogressBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotoScreen',
  props: {
    defaultUuid: {},
    selectedGender: {},
    selectedEpoch: {}
  },
  emits: ["show-result"],
  setup(__props: any, { emit: __emit }) {

const status = ref<"idle" | "loading" | "waiting-deepfake" | "error">("idle");

const title = computed(() => {
  return status.value === "waiting-deepfake"
    ? "Готовим гримёров..."
    : "Загрузите ваше фото";
});

const data = inject("data");
const props = __props;

const emit = __emit;

const preventDefaults = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

const imageUrl = ref("");
const error = ref("");
const errorEl = ref<HTMLDivElement | null>(null);

const isInViewport = (element: HTMLDivElement) => {
  const rect = element.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};
const scrollToError = () => {
  if (!errorEl.value) {
    return;
  }

  if (!isInViewport(errorEl.value)) {
    errorEl.value.scrollIntoView({ behavior: "smooth" });
  }
};

const fetchedUuid = ref("");

const sendDeepFakeRequest = async (id: string) => {
  const res = await fetch(`https://api.youth-day.ru/api/deepfakes/${id}`);
  return await res.json();
};

const getFilmById = async (id: string) => {
  const res = await fetch(`https://api.youth-day.ru/api/films/${id}`);
  return await res.json();
};

let currentInterval: ReturnType<typeof setTimeout> | null = null;
const findDeepFake = async (id: string) => {
  try {
    const { result_url, film_id } = await sendDeepFakeRequest(id);

    if (result_url) {
      const { title, result_text } = await getFilmById(film_id);

      emit("show-result", { result_url, result_text, title, uuid: id });
    } else {
      currentInterval = setTimeout(() => findDeepFake(id), 5000);
    }
  } catch (e) {
    console.log(e);
  }
};

const postDeepFake = async () => {
  status.value = "waiting-deepfake";

  let url = "https://api.youth-day.ru/api/deepfakes";

  const film_id = getFilmId(props.selectedGender, props.selectedEpoch);
  const data = JSON.stringify({ film_id, input_url: imageUrl.value });

  try {
    const res = await fetch(url, {
      method: "POST",
      body: data,
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.ok) {
      return;
    }
    const { id } = await res.json();
    window.history.pushState({}, "", `/result/${id}`);

    fetchedUuid.value = id;
    findDeepFake(id);
  } catch (err) {
    console.error(err);
  }
};

const uploadFile = async (file: File) => {
  error.value = "";

  let url = "https://api.youth-day.ru/api/image/upload";
  let formData = new FormData();
  status.value = "loading";

  formData.append("file", file);

  try {
    const res = await fetch(url, {
      method: "POST",
      body: formData,
    });
    if (!res.ok) {
      status.value = "error";
      const errorText = await res.text();

      if (errorText.includes("Input image doesn't contain")) {
        error.value = "Слишком много лиц на фотографии";
      } else if (errorText === "Invalid input image") {
        error.value = "Лицо на фотографии не найдено";
      } else {
        error.value = "Попробуйте загрузить другое изображение";
      }

      nextTick(() => {
        scrollToError();
      });

      return;
    }

    error.value = "";
    const { image_url } = await res.json();
    imageUrl.value = image_url;
    postDeepFake();
  } catch (e) {
    error.value = "Попробуйте загрузить другое изображение";
    status.value = "error";
  }
};

const handleDrop = (e: DragEvent) => {
  let dt = e.dataTransfer;

  if (!dt) {
    return;
  }

  let files = dt.files;

  uploadFile(files[0]);
};

onMounted(() => {
  let dropArea = document.getElementById("drop-area");

  if (!dropArea) {
    return;
  }
  const highlight = (e: DragEvent) => {
    if (!dropArea) {
      return;
    }
    dropArea.classList.add("highlight");
  };

  const unhighlight = (e: DragEvent) => {
    if (!dropArea) {
      return;
    }
    dropArea.classList.remove("highlight");
  };

  ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
    if (!dropArea) {
      return;
    }
    dropArea.addEventListener(eventName, preventDefaults, false);
  });
  dropArea.addEventListener("drop", handleDrop, false);
  ["dragenter", "dragover"].forEach((eventName) => {
    if (!dropArea) {
      return;
    }
    dropArea.addEventListener(eventName, highlight, false);
  });
  ["dragleave", "drop"].forEach((eventName) => {
    if (!dropArea) {
      return;
    }
    dropArea.addEventListener(eventName, unhighlight, false);
  });
});

const onChange = (e) => {
  uploadFile(e.target.files[0]);
};

status.value = props.defaultUuid ? "waiting-deepfake" : "idle";

if (props.defaultUuid) {
  findDeepFake(props.defaultUuid);
}
const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

let isFocused = true;
window.onblur = () => {
  isFocused = false;

  if (isMobile) {
    return;
  }

  if (currentInterval) {
    clearInterval(currentInterval);
    currentInterval = null;
  }
};

window.onfocus = () => {
  if (isMobile || isFocused) {
    return;
  }

  isFocused = true;

  if (currentInterval) {
    clearInterval(currentInterval);
    currentInterval = null;
  }

  findDeepFake(fetchedUuid.value);
};

onBeforeUnmount(() => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  window.onfocus = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  window.onblur = () => {};
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(SelectScreenTextBg, { class: "photo-screen__bg" }),
      _createElementVNode("p", _hoisted_2, _toDisplayString(title.value), 1)
    ]),
    _createElementVNode("div", {
      id: "drop-area",
      class: _normalizeClass({
        loading: status.value === 'loading' || status.value === 'waiting-deepfake',
      })
    }, [
      _createElementVNode("form", {
        class: "my-form",
        onChange: onChange
      }, [
        _createElementVNode("input", {
          type: "file",
          id: "fileElem",
          accept: "image/*",
          disabled: status.value === 'loading' || status.value === 'waiting-deepfake'
        }, null, 8, _hoisted_3),
        _createElementVNode("label", _hoisted_4, [
          (status.value === 'idle' || status.value === 'error')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7
              ], 64))
            : (status.value === 'loading')
              ? (_openBlock(), _createBlock(CircleLoader, { key: 1 }))
              : (status.value === 'waiting-deepfake')
                ? (_openBlock(), _createBlock(EmbededPogressBar, { key: 2 }))
                : _createCommentVNode("", true)
        ])
      ], 32)
    ], 2),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "errorEl",
          ref: errorEl,
          class: "error-message"
        }, _toDisplayString(error.value), 513))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: _unref(data)['man'],
      class: "photo-screen__man"
    }, null, 8, _hoisted_8),
    _createElementVNode("img", {
      src: _unref(data)['woman'],
      class: "photo-screen__woman"
    }, null, 8, _hoisted_9)
  ]))
}
}

})